import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../context/AuthContext';
import { applyInstitutionFilter } from '../lib/tenant';
import DptForm from '../components/Departamentos/DptForm';
import DptList from '../components/Departamentos/DptList';
import '../styles/DptPage.css';

export default function DptPage() {
  const { isAdmin, instituicaoId } = useAuth();
  const [departamentos, setDepartamentos] = useState([]);

  const fetchDepartamentos = useCallback(async () => {
    let query = supabase.from('departamentos').select('*').order('nome');
    query = applyInstitutionFilter(query, isAdmin, instituicaoId);
    const { data, error } = await query;
    if (error) console.error('Erro ao buscar departamentos:', error.message);
    else setDepartamentos(data);
  }, [isAdmin, instituicaoId]);

  useEffect(() => {
    fetchDepartamentos();
  }, [fetchDepartamentos]);

  const handleDptAdded = (dpt) => {
    setDepartamentos((prev) => [...prev, dpt]);
  };

  return (
    <div className="dpt-page">
      <h1>Departamentos</h1>
      <DptForm onDptAdded={handleDptAdded} />
      <DptList departamentos={departamentos} refresh={fetchDepartamentos} />
    </div>
  );
}
